<template>
  <div class="super-admin-page">
    <div class="modern-header">
      <div class="header-container">
        <div class="breadcrumb-section">
          <nav class="breadcrumb">
            <button type="button" class="breadcrumb-item" @click="$router.push('/dashboard')">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
              </svg>
              {{ t('common.breadcrumb.dashboard') }}
            </button>
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-current">{{ t('superAdmin.breadcrumb') }}</span>
          </nav>
        </div>

        <div class="title-section">
          <div class="title-content">
            <div class="title-icon title-icon--admin" aria-hidden="true">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
              </svg>
            </div>
            <div class="title-text">
              <h1 class="main-title">{{ t('superAdmin.title') }}</h1>
              <p class="subtitle">{{ t('superAdmin.subtitle') }}</p>
            </div>
          </div>

          <div class="workspace-badge badge-live">
            <span class="live-dot" aria-hidden="true"></span>
            <span class="badge-text">{{ t('superAdmin.live') }}</span>
          </div>
        </div>

        <div class="actions-section">
          <button type="button" class="action-button secondary" :disabled="loading" @click="carregar">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
            </svg>
            {{ t('superAdmin.refresh') }}
          </button>
        </div>
      </div>
    </div>

    <div class="sa-content">
      <!-- Resumo -->
      <div class="premium-card summary-dashboard">
        <div class="summary-dashboard__glow" aria-hidden="true"></div>
        <header class="panel-card__header panel-card__header--flush">
          <div class="panel-card__icon panel-card__icon--stats">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
            </svg>
          </div>
          <div>
            <h2 class="card-title">{{ t('superAdmin.summaryTitle') }}</h2>
            <p class="panel-card__subtitle">{{ t('superAdmin.summarySubtitle') }}</p>
          </div>
        </header>

        <div class="kpi-grid">
          <div class="kpi-card kpi-card--users">
            <div class="kpi-card__icon" aria-hidden="true">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"/>
              </svg>
            </div>
            <div class="kpi-card__body">
              <span class="kpi-label">{{ t('superAdmin.kpiUsers') }}</span>
              <strong class="kpi-value">{{ dashboard.totalUsuarios || 0 }}</strong>
            </div>
          </div>

          <div class="kpi-card kpi-card--workspaces">
            <div class="kpi-card__icon" aria-hidden="true">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"/>
              </svg>
            </div>
            <div class="kpi-card__body">
              <span class="kpi-label">{{ t('superAdmin.kpiWorkspaces') }}</span>
              <strong class="kpi-value">{{ dashboard.totalWorkspaces || 0 }}</strong>
            </div>
          </div>

          <div class="kpi-card kpi-card--cortesia" v-if="false">
            <div class="kpi-card__icon" aria-hidden="true">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8h-2A2.5 2.5 0 007 5.5V8m0 0v13m0-13h10m-10 0H7"/>
              </svg>
            </div>
            <div class="kpi-card__body">
              <span class="kpi-label">{{ t('superAdmin.kpiCourtesy') }}</span>
              <strong class="kpi-value">{{ totalEmCortesia }}</strong>
            </div>
          </div>
        </div>

        <div v-if="canManageUsers && cobrancaTotais" class="sa-billing-totals">
          <section
            v-for="section in billingTotalSections"
            :key="section.id"
            class="sa-billing-totals__group"
            :class="`sa-billing-totals__group--${section.id}`"
          >
            <header class="sa-billing-totals__head">
              <div class="sa-billing-totals__icon" aria-hidden="true">
                <svg v-if="section.id === 'paid'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                <svg v-else-if="section.id === 'due'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                </svg>
                <svg v-else fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
                </svg>
              </div>
              <div class="sa-billing-totals__head-text">
                <h3 class="sa-billing-totals__title">{{ t(section.titleKey) }}</h3>
                <p class="sa-billing-totals__summary">
                  {{ t('superAdmin.billing.totals.invoicesCount', { count: metricQtd(sectionResumo(section)) }) }}
                  <span class="sa-billing-totals__summary-sep">·</span>
                  <strong>{{ metricTotal(sectionResumo(section)) }}</strong>
                </p>
              </div>
            </header>
            <ul class="sa-billing-totals__list">
              <li
                v-for="row in section.rows"
                :key="row.key"
                class="sa-billing-totals__item"
                :class="{ 'sa-billing-totals__item--active': metricQtd(cobrancaTotais[row.key]) > 0 }"
              >
                <span class="sa-billing-totals__item-dot" aria-hidden="true" />
                <span class="sa-billing-totals__label">{{ t(row.labelKey) }}</span>
                <div class="sa-billing-totals__metric">
                  <span class="sa-billing-totals__pill">{{ metricQtd(cobrancaTotais[row.key]) }}</span>
                  <span class="sa-billing-totals__val">{{ metricTotal(cobrancaTotais[row.key]) }}</span>
                </div>
              </li>
            </ul>
          </section>
        </div>
      </div>

      <!-- Usuários -->
      <div class="premium-card panel-card users-card">
        <header class="panel-card__header">
          <div class="panel-card__icon panel-card__icon--users">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
            </svg>
          </div>
          <div class="panel-card__header-text">
            <h2 class="card-title">{{ t('superAdmin.usersTitle') }}</h2>
            <p class="panel-card__subtitle">{{ t('superAdmin.usersSubtitle') }}</p>
          </div>
          <span class="count-pill">{{ t('superAdmin.resultsCount', { count: filteredUsuarios.length }) }}</span>
          <button
            v-if="canCreateUser"
            type="button"
            class="sa-add-user-btn"
            @click="showCreateUserModal = true"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"/>
            </svg>
            {{ t('superAdmin.newUser') }}
          </button>
        </header>

        <div class="search-wrap">
          <svg class="search-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
          </svg>
          <input
            v-model="userSearch"
            class="search-input"
            type="text"
            :placeholder="t('superAdmin.searchUsers')"
          />
        </div>

        <div v-if="canManageUsers" class="sa-billing-toolbar">
          <div class="sa-billing-filters">
            <button
              type="button"
              class="sa-billing-filter"
              :class="{ 'sa-billing-filter--active': !billingFilter }"
              @click="clearBillingFilter"
            >
              {{ t('superAdmin.filterShowAllUsers') }}
            </button>
            <button
              v-for="chip in billingFilterChips"
              :key="chip.id"
              type="button"
              class="sa-billing-filter"
              :class="{ 'sa-billing-filter--active': billingFilter === chip.id }"
              @click="toggleBillingFilter(chip.id)"
            >
              {{ chip.label }}
            </button>
          </div>
          <select v-model="billingSort" class="sa-billing-sort" :aria-label="t('superAdmin.billing.sortLabel')">
            <option value="">{{ t('superAdmin.billing.sortDefault') }}</option>
            <option value="valorAsc">{{ t('superAdmin.billing.sortValorAsc') }}</option>
            <option value="valorDesc">{{ t('superAdmin.billing.sortValorDesc') }}</option>
            <option value="atrasoAsc">{{ t('superAdmin.billing.sortAtrasoAsc') }}</option>
            <option value="atrasoDesc">{{ t('superAdmin.billing.sortAtrasoDesc') }}</option>
          </select>
        </div>

        <div class="sa-users-shell">
          <div v-if="!paginatedUsuarios.length" class="sa-users-empty">
            <p>{{ t('superAdmin.emptyUsers') }}</p>
          </div>

          <div v-else class="sa-users-list">
            <div class="sa-users-list__head" aria-hidden="true">
              <span>{{ t('superAdmin.colUser') }}</span>
              <span>{{ t('superAdmin.colAccess') }} · {{ t('superAdmin.colWorkspaces') }}</span>
              <span>{{ t('superAdmin.colRole') }}</span>
            </div>

            <article
              v-for="usuario in paginatedUsuarios"
              :key="usuario.id"
              class="sa-user-row"
              :class="{
                'sa-user-row--clickable': canManageUsers,
                'sa-user-row--active': activeUserTools?.id === usuario.id
              }"
              :role="canManageUsers ? 'button' : undefined"
              :tabindex="canManageUsers ? 0 : undefined"
              @click="onUserRowClick(usuario)"
              @keydown.enter.prevent="onUserRowClick(usuario)"
            >
              <div class="sa-user-row__main">
                <div class="sa-user-row__id">
                  <div class="sa-user-row__avatar" :style="avatarStyle(usuario)" :aria-label="usuario.nomeCompleto">
                    {{ userInitials(usuario) }}
                  </div>
                  <div class="sa-user-row__text">
                    <div class="sa-user-row__name-line">
                      <span class="sa-user-row__name">{{ usuario.nomeCompleto }}</span>
                      <span class="sa-tag sa-tag--pro">Pro</span>
                      <span v-if="usuario.acessoBloqueado" class="sa-tag sa-tag--blocked">
                        {{ t('accountBlocked.blockedTag') }}
                      </span>
                      <span
                        v-if="usuario.cobrancaResumo?.temVencimentoProximos7Dias"
                        class="sa-billing-badge sa-billing-badge--warn"
                        :title="t('superAdmin.billing.badgeDue7')"
                      >
                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
                        </svg>
                      </span>
                      <span
                        v-if="usuario.cobrancaResumo?.qtdAtrasadas"
                        class="sa-billing-badge sa-billing-badge--overdue"
                        :title="overdueTooltip(usuario)"
                      >
                        {{ t('superAdmin.billing.badgeOverdue', { count: usuario.cobrancaResumo.qtdAtrasadas }) }}
                      </span>
                    </div>
                    <span class="sa-user-row__email">{{ usuario.email }}</span>
                    <div
                      v-if="usuario.temAssinaturaStripe || usuario.diaVencimentoCobranca || usuario.valorMensalCobranca"
                      class="sa-user-row__flags"
                    >
                      <span v-if="usuario.temAssinaturaStripe" class="sa-tag sa-tag--sm sa-tag--stripe">{{ t('superAdmin.stripe') }}</span>
                      <span v-if="usuario.valorMensalCobranca" class="sa-tag sa-tag--sm sa-tag--valor">
                        {{ t('superAdmin.billing.valorMensalTag', { value: formatMoneyAmount(usuario.valorMensalCobranca, locale) }) }}
                      </span>
                      <span v-if="usuario.diaVencimentoCobranca" class="sa-tag sa-tag--sm sa-tag--due">
                        {{ t('superAdmin.billingDueDayLabel', { day: usuario.diaVencimentoCobranca }) }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="sa-user-row__metrics">
                  <div class="sa-kpi" :class="{ 'sa-kpi--stale': accessInfo(usuario.ultimoAcessoEm).stale }">
                    <span class="sa-kpi__label">{{ t('superAdmin.colAccess') }}</span>
                    <div class="sa-kpi__access">
                      <span
                        class="sa-kpi__val"
                        :class="{ 'sa-kpi__val--stale': accessInfo(usuario.ultimoAcessoEm).stale }"
                        :title="accessInfo(usuario.ultimoAcessoEm).title"
                      >
                        <svg
                          v-if="accessInfo(usuario.ultimoAcessoEm).stale"
                          class="sa-kpi__warn-icon"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          aria-hidden="true"
                        >
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
                        </svg>
                        {{ accessInfo(usuario.ultimoAcessoEm).text }}
                      </span>
                      <span
                        v-if="accessInfo(usuario.ultimoAcessoEm).daysLabel"
                        class="sa-kpi__sub"
                        :class="{ 'sa-kpi__sub--stale': accessInfo(usuario.ultimoAcessoEm).stale }"
                      >
                        {{ accessInfo(usuario.ultimoAcessoEm).daysLabel }}
                      </span>
                    </div>
                  </div>
                  <div class="sa-kpi sa-kpi--ws">
                    <span class="sa-kpi__label">{{ t('superAdmin.colWorkspaces') }}</span>
                    <span class="sa-kpi__val">
                      <strong>{{ workspaceUsage(usuario).current }}</strong>
                      <template v-if="workspaceUsage(usuario).max != null">/{{ workspaceUsage(usuario).max }}</template>
                    </span>
                    <span
                      class="sa-kpi__bar"
                      :class="{ 'sa-kpi__bar--limit': workspaceUsage(usuario).atLimit }"
                      :style="{ '--pct': workspaceUsage(usuario).percent + '%' }"
                    />
                  </div>
                </div>

                <div class="sa-user-row__actions" @click.stop>
                  <div class="sa-user-row__actions-group">
                    <button
                      v-if="canManageUsers"
                      type="button"
                      class="sa-billing-btn"
                      :class="{ 'sa-billing-btn--active': activeUserBilling?.id === usuario.id }"
                      :title="t('superAdmin.billing.openDrawer')"
                      @click="openUserBilling(usuario)"
                    >
                      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z"/>
                      </svg>
                    </button>
                    <SuperAdminRolePicker
                      v-if="isSuperAdmin"
                      :model-value="usuario.roleNome"
                      :menu-open="activeRoleMenuUserId === usuario.id"
                      @update:menu-open="(open) => { activeRoleMenuUserId = open ? usuario.id : null }"
                      @change="alterarRole(usuario.id, $event)"
                    />
                    <SuperAdminRolePicker
                      v-else
                      :model-value="usuario.roleNome"
                      readonly
                    />
                    <span v-if="canManageUsers" class="sa-user-row__chevron" aria-hidden="true">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>

        <footer class="pagination">
          <span class="pagination-info">
            {{ t('superAdmin.showing', { start: paginationStart, end: paginationEnd, total: filteredUsuarios.length }) }}
          </span>
          <div class="pagination-controls">
            <button class="btn-page" type="button" :disabled="currentPage === 1" @click="prevPage">{{ t('superAdmin.prev') }}</button>
            <span class="page-indicator">{{ t('superAdmin.pageOf', { current: currentPage, total: totalPages }) }}</span>
            <button class="btn-page" type="button" :disabled="currentPage >= totalPages" @click="nextPage">{{ t('superAdmin.next') }}</button>
          </div>
        </footer>
      </div>

      <!-- Workspaces -->
      <div class="premium-card panel-card workspaces-card">
        <header class="panel-card__header">
          <div class="panel-card__icon panel-card__icon--ws">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"/>
            </svg>
          </div>
          <div class="panel-card__header-text">
            <h2 class="card-title">{{ t('superAdmin.workspacesTitle') }}</h2>
            <p class="panel-card__subtitle">{{ t('superAdmin.workspacesSubtitle') }}</p>
          </div>
          <span class="count-pill">{{ t('superAdmin.resultsCount', { count: filteredWorkspaces.length }) }}</span>
        </header>

        <div class="search-wrap">
          <svg class="search-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
          </svg>
          <input
            v-model="workspaceSearch"
            class="search-input"
            type="text"
            :placeholder="t('superAdmin.searchWorkspaces')"
          />
        </div>

        <div class="sa-ws-grid">
          <p v-if="!paginatedWorkspaces.length" class="sa-ws-empty">{{ t('superAdmin.emptyWorkspaces') }}</p>
          <article
            v-for="workspace in paginatedWorkspaces"
            :key="workspace.id"
            class="sa-ws-card"
            :class="{ 'sa-ws-card--inactive': !workspace.ativo }"
            :style="{ '--ws-accent': workspace.corWorkspace || '#5865F2' }"
          >
            <header class="sa-ws-card__head">
              <div
                class="sa-ws-card__thumb"
                :style="wsThumbStyle(workspace)"
              >
                <img
                  v-if="wsHasPhoto(workspace) && !wsFailedPhotos.has(workspace.id)"
                  :src="workspaceMediaSrc(workspace.fotoWorkspace)"
                  :alt="workspace.nome"
                  class="sa-ws-card__photo"
                  @error="markWsPhotoFailed(workspace.id)"
                />
                <span v-else class="sa-ws-card__initial">{{ wsInitial(workspace.nome) }}</span>
              </div>
              <div class="sa-ws-card__badges">
                <span class="tipo-badge" :class="wsTipoBadgeClass(workspace.tipo)">
                  {{ workspace.tipo }}
                </span>
                <span class="status-badge" :class="workspace.ativo ? 'status-active' : 'status-inactive'">
                  {{ workspace.ativo ? t('superAdmin.statusActive') : t('superAdmin.statusInactive') }}
                </span>
              </div>
            </header>
            <div class="sa-ws-card__body">
              <h3 class="sa-ws-card__name">{{ workspace.nome }}</h3>
              <div class="sa-ws-card__owner">
                <div
                  class="sa-ws-card__owner-avatar"
                  :style="wsOwnerAvatarStyle(workspace)"
                  :title="workspace.criadorNome || workspace.criadorEmail"
                >
                  <img
                    v-if="wsOwnerHasPhoto(workspace)"
                    :src="workspaceMediaSrc(workspace.criadorFotoPerfil)"
                    :alt="workspace.criadorNome || workspace.criadorEmail"
                    class="sa-ws-card__owner-photo"
                    @error="markWsOwnerPhotoFailed(workspace.id)"
                  />
                  <span v-else class="sa-ws-card__owner-initial">{{ wsOwnerInitials(workspace) }}</span>
                </div>
                <div class="sa-ws-card__owner-text">
                  <span class="sa-ws-card__owner-name">{{ workspace.criadorNome || t('nav.defaultUser') }}</span>
                  <span class="sa-ws-card__creator" :title="workspace.criadorEmail">{{ workspace.criadorEmail }}</span>
                </div>
              </div>
              <div v-if="(workspace.totalUsuarios || 0) > 0" class="sa-ws-card__members">
                <div class="sa-ws-card__member-stack">
                  <div
                    v-for="(membro, index) in (workspace.membros || []).slice(0, 4)"
                    :key="membro.id || index"
                    class="sa-ws-card__member-avatar"
                    :style="{ zIndex: 10 - index, marginLeft: index > 0 ? '-8px' : '0' }"
                    :title="membro.nomeCompleto"
                  >
                    <img
                      v-if="membro.fotoPerfil && !wsMemberFailedPhotos.has(`${workspace.id}-${membro.id}`)"
                      :src="workspaceMediaSrc(membro.fotoPerfil)"
                      :alt="membro.nomeCompleto"
                      @error="markWsMemberPhotoFailed(workspace.id, membro.id)"
                    />
                    <span v-else class="sa-ws-card__member-initial">{{ memberInitials(membro) }}</span>
                  </div>
                  <div
                    v-if="(workspace.totalUsuarios || 0) > 4"
                    class="sa-ws-card__member-avatar sa-ws-card__member-avatar--more"
                    style="margin-left: -8px"
                    :title="t('superAdmin.moreWorkspaceUsers', { count: (workspace.totalUsuarios || 0) - 4 })"
                  >
                    +{{ (workspace.totalUsuarios || 0) - 4 }}
                  </div>
                </div>
                <span class="sa-ws-card__member-count">
                  <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"/>
                  </svg>
                  {{ t('superAdmin.workspaceUsers', { count: workspace.totalUsuarios }) }}
                </span>
              </div>
            </div>
            <footer v-if="isSuperAdmin" class="sa-ws-card__foot">
              <button
                type="button"
                class="sa-ws-card__open"
                :title="t('superAdmin.openWorkspaceHint')"
                :disabled="openingWorkspaceId === workspace.id"
                @click="abrirWorkspace(workspace)"
              >
                <span v-if="openingWorkspaceId === workspace.id">{{ t('common.loading') }}</span>
                <span v-else>{{ t('superAdmin.openWorkspace') }}</span>
              </button>
            </footer>
          </article>
        </div>

        <footer class="pagination">
          <span class="pagination-info">
            {{ t('superAdmin.showing', { start: workspacePaginationStart, end: workspacePaginationEnd, total: filteredWorkspaces.length }) }}
          </span>
          <div class="pagination-controls">
            <button class="btn-page" type="button" :disabled="workspacePage === 1" @click="prevWorkspacePage">{{ t('superAdmin.prev') }}</button>
            <span class="page-indicator">{{ t('superAdmin.pageOf', { current: workspacePage, total: workspaceTotalPages }) }}</span>
            <button class="btn-page" type="button" :disabled="workspacePage >= workspaceTotalPages" @click="nextWorkspacePage">{{ t('superAdmin.next') }}</button>
          </div>
        </footer>
      </div>
    </div>

    <SuperAdminCreateUserModal
      v-model="showCreateUserModal"
      @created="carregar"
    />

    <SuperAdminUserToolsDrawer
      :open="!!activeUserTools"
      :usuario="activeUserTools"
      :draft-max-ws="activeUserTools ? draftMaxWs[activeUserTools.id] : undefined"
      :draft-dia-venc="activeUserTools ? draftDiaVenc[activeUserTools.id] : undefined"
      :draft-valor-mensal="activeUserTools ? draftValorMensal[activeUserTools.id] : undefined"
      :is-admin-role="activeUserTools ? isUsuarioAdminRole(activeUserTools) : false"
      :has-estruturacao="(screenId) => activeUserTools ? hasEstruturacaoAccess(activeUserTools, screenId) : false"
      @close="closeUserTools"
      @toggle-access="onDrawerToggleAccess"
      @toggle-create-ws="onDrawerToggleCreateWs"
      @apply-max-ws="onDrawerApplyMaxWs"
      @apply-dia-venc="onDrawerApplyDiaVenc"
      @apply-valor-mensal="onDrawerApplyValorMensal"
      @toggle-estrut="onDrawerToggleEstrut"
      @update:draft-max-ws="onDrawerUpdateMaxWs"
      @update:draft-dia-venc="onDrawerUpdateDiaVenc"
      @update:draft-valor-mensal="onDrawerUpdateValorMensal"
    />

    <SuperAdminUserBillingDrawer
      :open="!!activeUserBilling"
      :usuario="activeUserBilling"
      @close="closeUserBilling"
      @updated="onBillingUpdated"
    />
  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useToast } from 'vue-toastification'
import api from '../services/api'
import { useAuthStore } from '../stores/auth'
import { useGlobalWorkspaces } from '../composables/useGlobalWorkspaces'
import { markSuperAdminPreview } from '../composables/useSuperAdminWorkspacePreview'
import SuperAdminCreateUserModal from '../components/superadmin/SuperAdminCreateUserModal.vue'
import SuperAdminUserToolsDrawer from '../components/superadmin/SuperAdminUserToolsDrawer.vue'
import SuperAdminUserBillingDrawer from '../components/superadmin/SuperAdminUserBillingDrawer.vue'
import SuperAdminRolePicker from '../components/superadmin/SuperAdminRolePicker.vue'
import { resolveMediaUrl } from '@/config/app'
import { formatMoneyAmount } from '@/utils/format'
import { ESTRUTURACAO_SECTIONS } from '../constants/estruturacaoSections'

const { t, locale } = useI18n()
const toast = useToast()
const authStore = useAuthStore()
const { workspaces: globalWorkspaces, updateWorkspaceInList, selectWorkspace } = useGlobalWorkspaces()

const canManageUsers = computed(() => {
  const role = authStore.user?.role?.nome
  return role === 'SUPER_ADMIN' || role === 'ADMIN'
})
const canCreateUser = computed(() => authStore.user?.role?.nome === 'SUPER_ADMIN')
const isSuperAdmin = computed(() => authStore.isSuperAdmin)
const showCreateUserModal = ref(false)
const activeUserTools = ref(null)
const activeUserBilling = ref(null)
const activeRoleMenuUserId = ref(null)
const loading = ref(false)
const dashboard = ref({})
const usuarios = ref([])
const planos = ref([])
const workspaces = ref([])
const draftPlano = ref({})
const draftDias = ref({})
const draftMaxWs = ref({})
const draftDiaVenc = ref({})
const draftValorMensal = ref({})
const userSearch = ref('')
const billingFilter = ref('')
const billingSort = ref('')
const currentPage = ref(1)
const workspaceSearch = ref('')
const workspacePage = ref(1)
const openingWorkspaceId = ref(null)
const wsFailedPhotos = ref(new Set())
const wsOwnerFailedPhotos = ref(new Set())
const wsMemberFailedPhotos = ref(new Set())
const estruturacaoPermsByUser = ref({})
const userPageSize = 12
const workspacePageSize = 50

const totalEmCortesia = computed(() =>
  usuarios.value.filter((u) => u.cortesiaAte).length
)

const cobrancaTotais = computed(() => dashboard.value?.cobrancaTotais || null)

const billingTotalSections = [
  {
    id: 'paid',
    titleKey: 'superAdmin.billing.totals.paidTitle',
    rows: [
      { key: 'pagoHoje', labelKey: 'superAdmin.billing.totals.paidToday' },
      { key: 'pagoSemana', labelKey: 'superAdmin.billing.totals.paidWeek' },
      { key: 'pagoMes', labelKey: 'superAdmin.billing.totals.paidMonth' },
      { key: 'pagoMesPassado', labelKey: 'superAdmin.billing.totals.paidLastMonth' }
    ]
  },
  {
    id: 'due',
    titleKey: 'superAdmin.billing.totals.dueTitle',
    rows: [
      { key: 'venceHoje', labelKey: 'superAdmin.billing.totals.dueToday' },
      { key: 'venceAmanha', labelKey: 'superAdmin.billing.totals.dueTomorrow' },
      { key: 'venceProx7', labelKey: 'superAdmin.billing.totals.dueNext7' },
      { key: 'venceEsseMes', labelKey: 'superAdmin.billing.totals.dueThisMonth' },
      { key: 'venceMesQueVem', labelKey: 'superAdmin.billing.totals.dueNextMonth' }
    ]
  },
  {
    id: 'overdue',
    titleKey: 'superAdmin.billing.totals.overdueTitle',
    rows: [
      { key: 'atrasado7', labelKey: 'superAdmin.billing.totals.overdue7' },
      { key: 'atrasado30', labelKey: 'superAdmin.billing.totals.overdue30' },
      { key: 'atrasadoTodos', labelKey: 'superAdmin.billing.totals.overdueAll' }
    ]
  }
]

function metricQtd (metric) {
  return Number(metric?.qtd || 0)
}

function metricTotal (metric) {
  return formatMoneyAmount(metric?.total, locale.value)
}

const sectionResumoKey = {
  paid: 'resumoPagos',
  due: 'resumoAVencer',
  overdue: 'resumoAtrasados'
}

function sectionResumo (section) {
  const key = sectionResumoKey[section.id]
  return key && cobrancaTotais.value ? cobrancaTotais.value[key] : null
}

const billingFilterChips = computed(() => [
  { id: 'dueToday', label: t('superAdmin.billing.filterDueToday') },
  { id: 'due7', label: t('superAdmin.billing.filterDue7') },
  { id: 'overdue7', label: t('superAdmin.billing.filterOverdue7') },
  { id: 'overdue30', label: t('superAdmin.billing.filterOverdue30') },
  { id: 'allOverdue', label: t('superAdmin.billing.filterAllOverdue') }
])

function matchesBillingFilter (usuario) {
  if (!billingFilter.value) return true
  const r = usuario?.cobrancaResumo || {}
  switch (billingFilter.value) {
    case 'dueToday':
      return Boolean(r.venceHoje)
    case 'due7':
      return Boolean(r.temVencimentoProximos7Dias)
    case 'overdue7':
      return Number(r.qtdAtrasadas7Dias) > 0
    case 'overdue30':
      return Number(r.qtdAtrasadas30Dias) > 0
    case 'allOverdue':
      return Number(r.qtdAtrasadas) > 0
    default:
      return true
  }
}

function sortUsuarios (list) {
  const sort = billingSort.value
  if (!sort) return list
  const sorted = [...list]
  sorted.sort((a, b) => {
    if (sort === 'valorAsc' || sort === 'valorDesc') {
      const va = Number(a?.valorMensalCobranca ?? 0)
      const vb = Number(b?.valorMensalCobranca ?? 0)
      return sort === 'valorAsc' ? va - vb : vb - va
    }
    const da = Number(a?.cobrancaResumo?.diasAtrasoTotal ?? 0)
    const db = Number(b?.cobrancaResumo?.diasAtrasoTotal ?? 0)
    return sort === 'atrasoAsc' ? da - db : db - da
  })
  return sorted
}

const filteredUsuarios = computed(() => {
  const term = userSearch.value.trim().toLowerCase()
  let list = usuarios.value

  if (term) {
    list = list.filter((usuario) => {
      const nome = String(usuario?.nomeCompleto || '').toLowerCase()
      const email = String(usuario?.email || '').toLowerCase()
      const role = String(usuario?.roleNome || '').toLowerCase()
      const plano = String(usuario?.planoCodigo || '').toLowerCase()
      return nome.includes(term) || email.includes(term) || role.includes(term) || plano.includes(term)
    })
  }

  list = list.filter(matchesBillingFilter)
  return sortUsuarios(list)
})

function toggleBillingFilter (id) {
  billingFilter.value = billingFilter.value === id ? '' : id
}

function clearBillingFilter () {
  billingFilter.value = ''
}

function overdueTooltip (usuario) {
  const r = usuario?.cobrancaResumo || {}
  return t('superAdmin.billing.overdueTooltip', {
    days: r.diasAtrasoTotal || 0,
    value: formatMoneyAmount(r.valorAtrasadoTotal, locale.value)
  })
}

const totalPages = computed(() => {
  const total = Math.ceil(filteredUsuarios.value.length / userPageSize)
  return total > 0 ? total : 1
})

const paginatedUsuarios = computed(() => {
  const start = (currentPage.value - 1) * userPageSize
  return filteredUsuarios.value.slice(start, start + userPageSize)
})

const paginationStart = computed(() => {
  if (!filteredUsuarios.value.length) return 0
  return (currentPage.value - 1) * userPageSize + 1
})

const paginationEnd = computed(() => {
  if (!filteredUsuarios.value.length) return 0
  return Math.min(currentPage.value * userPageSize, filteredUsuarios.value.length)
})

const filteredWorkspaces = computed(() => {
  const term = workspaceSearch.value.trim().toLowerCase()
  if (!term) return workspaces.value

  return workspaces.value.filter((workspace) => {
    const id = String(workspace?.id ?? '').toLowerCase()
    const nome = String(workspace?.nome || '').toLowerCase()
    const tipo = String(workspace?.tipo || '').toLowerCase()
    const criador = String(workspace?.criadorEmail || '').toLowerCase()
    const ativo = workspace?.ativo ? 'sim' : 'não'
    return id.includes(term) || nome.includes(term) || tipo.includes(term) || criador.includes(term) || ativo.includes(term)
  })
})

const workspaceTotalPages = computed(() => {
  const total = Math.ceil(filteredWorkspaces.value.length / workspacePageSize)
  return total > 0 ? total : 1
})

const paginatedWorkspaces = computed(() => {
  const start = (workspacePage.value - 1) * workspacePageSize
  return filteredWorkspaces.value.slice(start, start + workspacePageSize)
})

const workspacePaginationStart = computed(() => {
  if (!filteredWorkspaces.value.length) return 0
  return (workspacePage.value - 1) * workspacePageSize + 1
})

const workspacePaginationEnd = computed(() => {
  if (!filteredWorkspaces.value.length) return 0
  return Math.min(workspacePage.value * workspacePageSize, filteredWorkspaces.value.length)
})

const wsTipoBadgeClass = (tipo) => {
  const key = String(tipo || '').toUpperCase()
  if (key === 'CRM') return 'tipo-badge--crm'
  if (key === 'SERVICOS') return 'tipo-badge--servicos'
  return 'tipo-badge--task'
}

const wsHasPhoto = (workspace) => Boolean(workspace?.fotoWorkspace?.trim())

const workspaceMediaSrc = (url) => {
  const resolved = resolveMediaUrl(url)
  return resolved || ''
}

const wsInitial = (nome) => {
  const trimmed = String(nome || '').trim()
  return trimmed ? trimmed.charAt(0).toUpperCase() : '?'
}

const wsThumbStyle = (workspace) => {
  if (wsHasPhoto(workspace) && !wsFailedPhotos.value.has(workspace.id)) {
    return {}
  }
  return {
    backgroundColor: workspace?.corWorkspace || '#5865F2',
    color: '#fff'
  }
}

const markWsPhotoFailed = (workspaceId) => {
  if (wsFailedPhotos.value.has(workspaceId)) return
  wsFailedPhotos.value = new Set([...wsFailedPhotos.value, workspaceId])
}

const wsOwnerHasPhoto = (workspace) => Boolean(workspace?.criadorFotoPerfil?.trim()) && !wsOwnerFailedPhotos.value.has(workspace.id)

const wsOwnerInitials = (workspace) => {
  const name = String(workspace?.criadorNome || workspace?.criadorEmail || '?').trim()
  const parts = name.split(/\s+/).filter(Boolean)
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
  }
  return name.slice(0, 2).toUpperCase()
}

const wsOwnerAvatarStyle = (workspace) => {
  if (wsOwnerHasPhoto(workspace)) return {}
  const seed = String(workspace?.criadorEmail || workspace?.id || 0)
  let hash = 0
  for (let i = 0; i < seed.length; i++) hash = seed.charCodeAt(i) + ((hash << 5) - hash)
  const [a, b] = AVATAR_GRADIENTS[Math.abs(hash) % AVATAR_GRADIENTS.length]
  return { background: `linear-gradient(135deg, ${a} 0%, ${b} 100%)` }
}

const markWsOwnerPhotoFailed = (workspaceId) => {
  if (wsOwnerFailedPhotos.value.has(workspaceId)) return
  wsOwnerFailedPhotos.value = new Set([...wsOwnerFailedPhotos.value, workspaceId])
}

const memberInitials = (membro) => {
  const name = String(membro?.nomeCompleto || '?').trim()
  const parts = name.split(/\s+/).filter(Boolean)
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
  }
  return name.slice(0, 2).toUpperCase()
}

const markWsMemberPhotoFailed = (workspaceId, memberId) => {
  const key = `${workspaceId}-${memberId}`
  if (wsMemberFailedPhotos.value.has(key)) return
  wsMemberFailedPhotos.value = new Set([...wsMemberFailedPhotos.value, key])
}

const abrirWorkspace = async (workspace) => {
  if (!isSuperAdmin.value || !workspace?.id) return
  openingWorkspaceId.value = workspace.id
  try {
    const { data } = await api.get(`/super-admin/workspaces/${workspace.id}`)
    const exists = globalWorkspaces.value.some((w) => w.id === data.id)
    if (exists) {
      updateWorkspaceInList(data)
    } else {
      globalWorkspaces.value.push(data)
    }
    markSuperAdminPreview(data.id)
    await selectWorkspace(data)
  } catch (err) {
    toast.error(err.response?.data?.error || t('superAdmin.openWorkspaceError'))
  } finally {
    openingWorkspaceId.value = null
  }
}

const nextPage = () => {
  if (currentPage.value < totalPages.value) currentPage.value += 1
}

const prevPage = () => {
  if (currentPage.value > 1) currentPage.value -= 1
}

const nextWorkspacePage = () => {
  if (workspacePage.value < workspaceTotalPages.value) workspacePage.value += 1
}

const prevWorkspacePage = () => {
  if (workspacePage.value > 1) workspacePage.value -= 1
}

const buildEstruturacaoPerms = (allPerms) => {
  const map = {}
  for (const perm of allPerms || []) {
    if (!perm?.tela?.startsWith('estruturacao-')) continue
    if (!map[perm.usuarioId]) map[perm.usuarioId] = {}
    map[perm.usuarioId][perm.tela] = perm.temAcesso === true
  }
  estruturacaoPermsByUser.value = map
}

const isUsuarioAdminRole = (usuario) => {
  const role = usuario?.roleNome
  return role === 'ADMIN' || role === 'SUPER_ADMIN'
}

const hasEstruturacaoAccess = (usuario, screenId) => {
  if (isUsuarioAdminRole(usuario)) return true
  return estruturacaoPermsByUser.value[usuario.id]?.[screenId] === true
}

const toggleEstruturacaoAccess = async (usuario, screenId, enabled) => {
  if (isUsuarioAdminRole(usuario)) return

  const prev = estruturacaoPermsByUser.value[usuario.id]?.[screenId] ?? false
  if (!estruturacaoPermsByUser.value[usuario.id]) {
    estruturacaoPermsByUser.value[usuario.id] = {}
  }
  estruturacaoPermsByUser.value[usuario.id][screenId] = enabled

  try {
    await api.put(`/permissoes-tela/usuario/${usuario.id}/item`, {
      tela: screenId,
      temAcesso: enabled
    })
    toast.success(
      enabled
        ? t('superAdmin.estruturacao.enabled', { section: t(`superAdmin.estruturacao.${screenId}`) })
        : t('superAdmin.estruturacao.disabled', { section: t(`superAdmin.estruturacao.${screenId}`) })
    )
  } catch (err) {
    estruturacaoPermsByUser.value[usuario.id][screenId] = prev
    toast.error(err.response?.data?.message || err.response?.data?.error || t('superAdmin.estruturacao.error'))
  }
}

const carregar = async () => {
  loading.value = true
  try {
    const [dashResp, usersResp, planosResp, workspaceResp] = await Promise.all([
      api.get('/super-admin/dashboard'),
      api.get('/super-admin/usuarios'),
      api.get('/planos'),
      api.get('/super-admin/workspaces')
    ])
    dashboard.value = dashResp.data || {}
    usuarios.value = usersResp.data || []
    planos.value = planosResp.data || []
    workspaces.value = workspaceResp.data || []

    if (canManageUsers.value) {
      try {
        const { data } = await api.get('/permissoes-tela/todas')
        buildEstruturacaoPerms(data)
      } catch (err) {
        console.warn('[SUPER_ADMIN] Não foi possível carregar permissões de estruturação:', err)
        estruturacaoPermsByUser.value = {}
      }
    }

    wsFailedPhotos.value = new Set()
    syncDraftsFromUsuarios()
  } finally {
    loading.value = false
  }
}

const syncDraftsFromUsuarios = () => {
  const planoMap = {}
  const diasMap = {}
  const maxWsMap = {}
  const diaVencMap = {}
  const valorMensalMap = {}
  for (const u of usuarios.value) {
    planoMap[u.id] = u.planoCodigo || 'FREE'
    diasMap[u.id] = 0
    maxWsMap[u.id] = u.maxWorkspacesOverride ?? ''
    diaVencMap[u.id] = u.diaVencimentoCobranca ?? ''
    valorMensalMap[u.id] = u.valorMensalCobranca ?? ''
  }
  draftPlano.value = planoMap
  draftDias.value = diasMap
  draftMaxWs.value = maxWsMap
  draftDiaVenc.value = diaVencMap
  draftValorMensal.value = valorMensalMap
  refreshActiveUserRefs()
}

function refreshActiveUserRefs () {
  if (activeUserTools.value) {
    const found = usuarios.value.find((u) => u.id === activeUserTools.value.id)
    if (found) activeUserTools.value = found
  }
  if (activeUserBilling.value) {
    const found = usuarios.value.find((u) => u.id === activeUserBilling.value.id)
    if (found) activeUserBilling.value = found
  }
}

const userInitials = (usuario) => {
  const name = String(usuario?.nomeCompleto || '?').trim()
  const parts = name.split(/\s+/).filter(Boolean)
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
  }
  return name.slice(0, 2).toUpperCase()
}

const labelPlano = (codigo) => {
  const p = planos.value.find((x) => x.codigo === codigo)
  return p?.nome || codigo
}

const formatCortesiaDate = (iso) => {
  if (!iso) return ''
  try {
    return new Date(iso).toLocaleDateString(locale.value)
  } catch {
    return iso
  }
}

const formatDateTime = (iso) => {
  if (!iso) return '—'
  try {
    return new Date(iso).toLocaleString(locale.value, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  } catch {
    return iso
  }
}

const STALE_ACCESS_DAYS = 10

const parseAccessDate = (iso) => {
  if (!iso) return null
  const normalized = String(iso).trim().replace(' ', 'T')
  const d = new Date(normalized)
  return Number.isNaN(d.getTime()) ? null : d
}

const accessInfo = (iso) => {
  const date = parseAccessDate(iso)
  if (!date) {
    return {
      text: t('superAdmin.neverAccessed'),
      daysLabel: null,
      stale: true,
      title: t('superAdmin.accessStaleHint', { days: STALE_ACCESS_DAYS })
    }
  }
  const days = Math.floor((Date.now() - date.getTime()) / 86400000)
  const stale = days > STALE_ACCESS_DAYS
  const text = date.toLocaleString(locale.value, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
  let daysLabel
  if (days <= 0) {
    daysLabel = t('superAdmin.accessToday')
  } else if (days === 1) {
    daysLabel = t('superAdmin.accessOneDay')
  } else {
    daysLabel = t('superAdmin.accessDaysAgo', { days })
  }
  return {
    text,
    daysLabel,
    stale,
    title: stale ? t('superAdmin.accessStaleHint', { days }) : text
  }
}

const formatAccessCompact = (iso) => accessInfo(iso).text

const AVATAR_GRADIENTS = [
  ['#6366f1', '#8b5cf6'],
  ['#0ea5e9', '#6366f1'],
  ['#14b8a6', '#22c55e'],
  ['#f59e0b', '#ef4444'],
  ['#ec4899', '#8b5cf6']
]

const avatarStyle = (usuario) => {
  const seed = String(usuario?.email || usuario?.id || 0)
  let hash = 0
  for (let i = 0; i < seed.length; i++) hash = seed.charCodeAt(i) + ((hash << 5) - hash)
  const [a, b] = AVATAR_GRADIENTS[Math.abs(hash) % AVATAR_GRADIENTS.length]
  return { background: `linear-gradient(135deg, ${a} 0%, ${b} 100%)` }
}

const planChipClass = (codigo) => {
  const c = String(codigo || 'FREE').toUpperCase()
  if (c.includes('PRO')) return 'sa-tag--pro'
  if (c.includes('START')) return 'sa-tag--start'
  if (c.includes('CORP')) return 'sa-tag--corp'
  return 'sa-tag--free'
}

const workspaceUsage = (usuario) => {
  const current = Number(usuario?.totalWorkspaces ?? 0)
  const max = usuario?.maxWorkspacesOverride
  if (max == null || max <= 0) {
    return { current, max: null, percent: Math.min(current * 12, 100), atLimit: false }
  }
  const percent = Math.min(100, Math.round((current / max) * 100))
  return { current, max, percent, atLimit: current >= max }
}

const alterarRole = async (usuarioId, roleNome) => {
  await api.put(`/super-admin/usuarios/${usuarioId}/role`, { roleNome })
  await carregar()
}

const aplicarMaxWorkspaces = async (usuarioId) => {
  const raw = draftMaxWs.value[usuarioId]
  const maxWorkspaces = raw === '' || raw == null ? null : Number(raw)
  if (maxWorkspaces != null && (!Number.isFinite(maxWorkspaces) || maxWorkspaces < 0)) {
    toast.error(t('superAdmin.maxWorkspacesInvalid'))
    return
  }
  try {
    await api.put(`/super-admin/usuarios/${usuarioId}/max-workspaces`, { maxWorkspaces })
    toast.success(t('superAdmin.maxWorkspacesSaved'))
    await carregar()
  } catch (err) {
    toast.error(err.response?.data?.error || t('superAdmin.maxWorkspacesError'))
  }
}

const aplicarDiaVencimento = async (usuarioId) => {
  const raw = draftDiaVenc.value[usuarioId]
  const diaVencimento = raw === '' || raw == null ? null : Number(raw)
  if (diaVencimento != null && (!Number.isInteger(diaVencimento) || diaVencimento < 1 || diaVencimento > 31)) {
    toast.error(t('superAdmin.billingDueDayInvalid'))
    return
  }
  try {
    await api.put(`/super-admin/usuarios/${usuarioId}/dia-vencimento`, { diaVencimento })
    toast.success(t('superAdmin.billingDueDaySaved'))
    await carregar()
  } catch (err) {
    toast.error(err.response?.data?.error || t('superAdmin.billingDueDayError'))
  }
}

const aplicarValorMensal = async (usuarioId) => {
  const raw = draftValorMensal.value[usuarioId]
  const valorMensal = raw === '' || raw == null ? null : Number(raw)
  if (valorMensal != null && (!Number.isFinite(valorMensal) || valorMensal < 0)) {
    toast.error(t('superAdmin.billing.valorInvalid'))
    return
  }
  try {
    await api.put(`/super-admin/usuarios/${usuarioId}/valor-mensal`, { valorMensal })
    toast.success(t('superAdmin.billing.valorSaved'))
    await carregar()
  } catch (err) {
    toast.error(err.response?.data?.error || t('superAdmin.billing.valorError'))
  }
}

function openUserBilling (usuario) {
  activeRoleMenuUserId.value = null
  activeUserBilling.value = usuario
}

function closeUserBilling () {
  activeUserBilling.value = null
}

function onBillingUpdated () {
  carregar()
}

function onUserRowClick (usuario) {
  if (!canManageUsers.value) return
  activeRoleMenuUserId.value = null
  activeUserTools.value = usuario
}

function closeUserTools () {
  activeUserTools.value = null
}

function onDrawerToggleAccess (checked) {
  if (!activeUserTools.value) return
  toggleAcessoBloqueado(activeUserTools.value, checked)
}

function onDrawerToggleCreateWs (checked) {
  if (!activeUserTools.value) return
  togglePodeCriarWorkspace(activeUserTools.value, checked)
}

function onDrawerApplyMaxWs () {
  if (!activeUserTools.value) return
  aplicarMaxWorkspaces(activeUserTools.value.id)
}

function onDrawerApplyDiaVenc () {
  if (!activeUserTools.value) return
  aplicarDiaVencimento(activeUserTools.value.id)
}

function onDrawerApplyValorMensal () {
  if (!activeUserTools.value) return
  aplicarValorMensal(activeUserTools.value.id)
}

function onDrawerToggleEstrut (screenId, checked) {
  if (!activeUserTools.value) return
  toggleEstruturacaoAccess(activeUserTools.value, screenId, checked)
}

function onDrawerUpdateMaxWs (value) {
  if (!activeUserTools.value) return
  draftMaxWs.value[activeUserTools.value.id] = value
}

function onDrawerUpdateDiaVenc (value) {
  if (!activeUserTools.value) return
  draftDiaVenc.value[activeUserTools.value.id] = value
}

function onDrawerUpdateValorMensal (value) {
  if (!activeUserTools.value) return
  draftValorMensal.value[activeUserTools.value.id] = value
}

const toggleAcessoBloqueado = async (usuario, ativo) => {
  const bloqueado = !ativo
  const prev = usuario.acessoBloqueado
  usuario.acessoBloqueado = bloqueado
  try {
    await api.put(`/super-admin/usuarios/${usuario.id}/acesso-bloqueado`, { bloqueado })
    toast.success(bloqueado ? t('accountBlocked.accessBlocked') : t('accountBlocked.accessActive'))
  } catch (err) {
    usuario.acessoBloqueado = prev
    toast.error(err.response?.data?.error || t('superAdmin.maxWorkspacesError'))
  }
}

const togglePodeCriarWorkspace = async (usuario, podeCriar) => {
  const prev = usuario.podeCriarWorkspace
  usuario.podeCriarWorkspace = podeCriar
  try {
    await api.put(`/super-admin/usuarios/${usuario.id}/pode-criar-workspace`, { podeCriar })
    toast.success(
      podeCriar ? t('superAdmin.podeCriarWorkspaceActive') : t('superAdmin.podeCriarWorkspaceInactive')
    )
  } catch (err) {
    usuario.podeCriarWorkspace = prev
    toast.error(err.response?.data?.error || t('superAdmin.maxWorkspacesError'))
  }
}

watch(paginatedUsuarios, (list) => {
  if (activeUserTools.value && !list.some((u) => u.id === activeUserTools.value.id)) {
    activeUserTools.value = null
  }
  if (activeUserBilling.value && !list.some((u) => u.id === activeUserBilling.value.id)) {
    activeUserBilling.value = null
  }
})

watch(userSearch, () => { currentPage.value = 1 })
watch(billingFilter, () => { currentPage.value = 1 })
watch(billingSort, () => { currentPage.value = 1 })
watch(totalPages, (newTotal) => {
  if (currentPage.value > newTotal) currentPage.value = newTotal
})
watch(workspaceSearch, () => { workspacePage.value = 1 })
watch(workspaceTotalPages, (newTotal) => {
  if (workspacePage.value > newTotal) workspacePage.value = newTotal
})

onMounted(carregar)
</script>

<style scoped>
.super-admin-page {
  min-height: 100%;
  background: linear-gradient(135deg, var(--bg-primary) 0%, var(--bg-secondary) 100%);
  color: var(--text-primary);
}

/* Header (padrão Meu Perfil) */
.modern-header {
  background: var(--bg-primary);
  border-bottom: 1px solid var(--border-primary);
  padding: 24px 0;
}

.header-container {
  width: 100%;
  padding: 0 24px;
}

.breadcrumb-section {
  margin-bottom: 16px;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  flex-wrap: wrap;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  font-weight: 500;
}

.breadcrumb-item:hover {
  background: var(--bg-secondary);
  color: var(--text-primary);
}

.breadcrumb-separator {
  color: var(--text-tertiary);
  font-weight: 500;
}

.breadcrumb-current {
  color: var(--text-primary);
  font-weight: 600;
  padding: 6px 12px;
  background: var(--bg-secondary);
  border-radius: 4px;
}

.title-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.title-content {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  min-width: 0;
}

.title-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 4px;
  color: white;
  flex-shrink: 0;
}

.title-icon--admin {
  background: linear-gradient(135deg, #f59e0b 0%, #ef4444 100%);
  box-shadow: 0 4px 16px rgba(239, 68, 68, 0.35);
}

.main-title {
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  line-height: 1.2;
}

.subtitle {
  font-size: 1rem;
  color: var(--text-secondary);
  margin: 4px 0 0;
}

.workspace-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  flex-shrink: 0;
}

.badge-live {
  background: rgba(34, 197, 94, 0.1);
  border: 1px solid rgba(34, 197, 94, 0.35);
  color: #22c55e;
}

.live-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.5);
  animation: pulse-live 2s ease infinite;
}

@keyframes pulse-live {
  0%, 100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.45); }
  50% { box-shadow: 0 0 0 6px rgba(34, 197, 94, 0); }
}

.actions-section {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.action-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.action-button.secondary {
  background: var(--bg-secondary);
  border-color: var(--border-primary);
  color: var(--text-primary);
}

.action-button.secondary:hover:not(:disabled) {
  background: var(--bg-primary);
  border-color: color-mix(in srgb, var(--accent-primary) 40%, var(--border-primary));
}

.action-button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* Content */
.sa-content {
  padding: 28px 24px 40px;
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.premium-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 4px;
  padding: 20px;
  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.06);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.panel-card:hover {
  border-color: color-mix(in srgb, #6366f1 22%, var(--border-primary));
  box-shadow: 0 14px 36px rgba(15, 23, 42, 0.1);
}

.summary-dashboard {
  position: relative;
  overflow: hidden;
  padding: 22px 20px 20px;
  background:
    radial-gradient(ellipse 70% 55% at 100% 0%, color-mix(in srgb, #6366f1 16%, transparent), transparent 55%),
    radial-gradient(ellipse 50% 45% at 0% 100%, color-mix(in srgb, #f59e0b 10%, transparent), transparent 50%),
    var(--bg-secondary);
  border-color: color-mix(in srgb, #6366f1 18%, var(--border-primary));
}

.summary-dashboard__glow {
  position: absolute;
  top: -30%;
  right: -10%;
  width: 50%;
  height: 100%;
  background: radial-gradient(circle, color-mix(in srgb, #6366f1 12%, transparent), transparent 70%);
  pointer-events: none;
}

.panel-card__header:has(.sa-add-user-btn) {
  flex-wrap: wrap;
  gap: 10px;
}

.panel-card__header {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 18px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--border-primary);
  flex-wrap: wrap;
}

.panel-card__header--flush {
  position: relative;
  z-index: 1;
}

.panel-card__header-text {
  flex: 1;
  min-width: 160px;
}

.panel-card__icon {
  width: 42px;
  height: 42px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
}

.panel-card__icon--stats {
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.35);
}

.panel-card__icon--users {
  background: linear-gradient(135deg, #0ea5e9, #6366f1);
  box-shadow: 0 4px 14px rgba(14, 165, 233, 0.35);
}

.panel-card__icon--ws {
  background: linear-gradient(135deg, #22c55e, #14b8a6);
  box-shadow: 0 4px 14px rgba(34, 197, 94, 0.35);
}

.card-title {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.panel-card__subtitle {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.45;
}

.count-pill {
  margin-left: auto;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 999px;
  padding: 5px 12px;
  background: var(--bg-primary);
  white-space: nowrap;
}

/* KPI */
.kpi-grid {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 20px;
}

.kpi-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  background: color-mix(in srgb, var(--bg-primary) 65%, transparent);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.kpi-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);
}

.kpi-card__icon {
  width: 44px;
  height: 44px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
}

.kpi-card--users .kpi-card__icon {
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
}

.kpi-card--workspaces .kpi-card__icon {
  background: linear-gradient(135deg, #22c55e, #14b8a6);
}

.kpi-card--cortesia .kpi-card__icon {
  background: linear-gradient(135deg, #f59e0b, #f97316);
}

.kpi-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-secondary);
}

.kpi-value {
  display: block;
  margin-top: 4px;
  font-size: 1.75rem;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.03em;
}

.sa-billing-totals {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.sa-billing-totals__group {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--border-primary);
  border-radius: 4px;
  overflow: hidden;
  background: var(--bg-primary);
  box-shadow: 0 2px 10px color-mix(in srgb, #000 5%, transparent);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.sa-billing-totals__group:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 24px color-mix(in srgb, #000 9%, transparent);
}

.sa-billing-totals__group--paid .sa-billing-totals__head {
  background: linear-gradient(135deg, color-mix(in srgb, #22c55e 14%, var(--bg-card)) 0%, var(--bg-card) 72%);
  border-bottom-color: color-mix(in srgb, #22c55e 22%, var(--border-primary));
}

.sa-billing-totals__group--paid .sa-billing-totals__icon {
  background: linear-gradient(135deg, #22c55e, #14b8a6);
  box-shadow: 0 4px 14px color-mix(in srgb, #22c55e 32%, transparent);
}

.sa-billing-totals__group--paid .sa-billing-totals__item--active {
  border-color: color-mix(in srgb, #22c55e 28%, var(--border-primary));
  background: color-mix(in srgb, #22c55e 7%, var(--bg-secondary));
}

.sa-billing-totals__group--paid .sa-billing-totals__item--active .sa-billing-totals__item-dot {
  background: #22c55e;
  box-shadow: 0 0 0 3px color-mix(in srgb, #22c55e 22%, transparent);
}

.sa-billing-totals__group--paid .sa-billing-totals__pill {
  color: #15803d;
  background: color-mix(in srgb, #22c55e 14%, var(--bg-primary));
  border-color: color-mix(in srgb, #22c55e 26%, transparent);
}

.sa-billing-totals__group--due .sa-billing-totals__head {
  background: linear-gradient(135deg, color-mix(in srgb, #6366f1 14%, var(--bg-card)) 0%, var(--bg-card) 72%);
  border-bottom-color: color-mix(in srgb, #6366f1 22%, var(--border-primary));
}

.sa-billing-totals__group--due .sa-billing-totals__icon {
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  box-shadow: 0 4px 14px color-mix(in srgb, #6366f1 32%, transparent);
}

.sa-billing-totals__group--due .sa-billing-totals__item--active {
  border-color: color-mix(in srgb, #6366f1 28%, var(--border-primary));
  background: color-mix(in srgb, #6366f1 7%, var(--bg-secondary));
}

.sa-billing-totals__group--due .sa-billing-totals__item--active .sa-billing-totals__item-dot {
  background: #6366f1;
  box-shadow: 0 0 0 3px color-mix(in srgb, #6366f1 22%, transparent);
}

.sa-billing-totals__group--due .sa-billing-totals__pill {
  color: #4f46e5;
  background: color-mix(in srgb, #6366f1 14%, var(--bg-primary));
  border-color: color-mix(in srgb, #6366f1 26%, transparent);
}

.sa-billing-totals__group--overdue .sa-billing-totals__head {
  background: linear-gradient(135deg, color-mix(in srgb, #ef4444 12%, var(--bg-card)) 0%, var(--bg-card) 72%);
  border-bottom-color: color-mix(in srgb, #ef4444 22%, var(--border-primary));
}

.sa-billing-totals__group--overdue .sa-billing-totals__icon {
  background: linear-gradient(135deg, #ef4444, #f97316);
  box-shadow: 0 4px 14px color-mix(in srgb, #ef4444 30%, transparent);
}

.sa-billing-totals__group--overdue .sa-billing-totals__item--active {
  border-color: color-mix(in srgb, #ef4444 28%, var(--border-primary));
  background: color-mix(in srgb, #ef4444 7%, var(--bg-secondary));
}

.sa-billing-totals__group--overdue .sa-billing-totals__item--active .sa-billing-totals__item-dot {
  background: #ef4444;
  box-shadow: 0 0 0 3px color-mix(in srgb, #ef4444 20%, transparent);
}

.sa-billing-totals__group--overdue .sa-billing-totals__pill {
  color: #b91c1c;
  background: color-mix(in srgb, #ef4444 12%, var(--bg-primary));
  border-color: color-mix(in srgb, #ef4444 24%, transparent);
}

.sa-billing-totals__head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--border-primary);
}

.sa-billing-totals__icon {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
}

.sa-billing-totals__icon svg {
  width: 20px;
  height: 20px;
}

.sa-billing-totals__head-text {
  min-width: 0;
}

.sa-billing-totals__title {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-secondary);
}

.sa-billing-totals__summary {
  margin: 4px 0 0;
  font-size: 12px;
  color: var(--text-secondary);
  line-height: 1.35;
}

.sa-billing-totals__summary strong {
  font-size: 15px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--text-primary);
}

.sa-billing-totals__summary-sep {
  margin: 0 4px;
  opacity: 0.55;
}

.sa-billing-totals__list {
  margin: 0;
  padding: 10px 12px 12px;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.sa-billing-totals__item {
  display: grid;
  grid-template-columns: 8px 1fr auto;
  align-items: center;
  gap: 8px 10px;
  padding: 9px 10px;
  border-radius: 4px;
  border: 1px solid transparent;
  background: color-mix(in srgb, var(--bg-secondary) 45%, transparent);
  transition: border-color 0.15s ease, background 0.15s ease;
}

.sa-billing-totals__item-dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: color-mix(in srgb, var(--text-secondary) 35%, transparent);
}

.sa-billing-totals__label {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  line-height: 1.3;
}

.sa-billing-totals__item--active .sa-billing-totals__label {
  color: var(--text-primary);
}

.sa-billing-totals__metric {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.sa-billing-totals__pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 26px;
  height: 22px;
  padding: 0 7px;
  border-radius: 999px;
  border: 1px solid var(--border-primary);
  font-size: 11px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: var(--text-tertiary, var(--text-secondary));
  background: var(--bg-primary);
}

.sa-billing-totals__item--active .sa-billing-totals__pill {
  font-weight: 800;
}

.sa-billing-totals__val {
  min-width: 72px;
  font-size: 12px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--text-tertiary, var(--text-secondary));
  text-align: right;
  white-space: nowrap;
}

.sa-billing-totals__item--active .sa-billing-totals__val {
  font-size: 13px;
  font-weight: 800;
  color: var(--text-primary);
}

/* Search */
.search-wrap {
  position: relative;
  margin-bottom: 14px;
}

.search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  color: var(--text-secondary);
  pointer-events: none;
}

.search-input {
  width: 100%;
  padding: 12px 14px 12px 42px;
  border: 1px solid var(--border-primary);
  background: var(--bg-primary);
  color: var(--text-primary);
  border-radius: 10px;
  font-size: 14px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.search-input:focus {
  outline: none;
  border-color: color-mix(in srgb, var(--accent-primary) 50%, var(--border-primary));
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent-primary) 15%, transparent);
}

/* Lista de usuários (compacta) */
.sa-users-shell {
  display: flex;
  flex-direction: column;
}

.sa-users-empty {
  padding: 32px 20px;
  text-align: center;
  border-radius: 10px;
  border: 1px dashed var(--border-primary);
  background: color-mix(in srgb, var(--bg-secondary) 75%, transparent);
  color: var(--text-secondary);
  font-size: 13px;
}

.sa-users-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 2px 0 4px;
}

.sa-users-list__head {
  display: grid;
  grid-template-columns: minmax(200px, 1.5fr) minmax(160px, 1fr) minmax(168px, auto);
  gap: 10px;
  align-items: center;
  padding: 10px 16px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--text-tertiary, var(--text-secondary));
  background: color-mix(in srgb, var(--bg-secondary) 85%, var(--bg-primary));
  border: 1px solid var(--border-primary);
  border-radius: 4px;
}

.sa-user-row {
  border: 1px solid var(--border-primary);
  border-radius: 4px;
  background: var(--bg-primary);
  box-shadow: 0 1px 3px color-mix(in srgb, #000 4%, transparent);
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}

.sa-user-row--clickable {
  cursor: pointer;
}

.sa-user-row--clickable:hover {
  border-color: color-mix(in srgb, #6366f1 40%, var(--border-primary));
  box-shadow: 0 4px 14px color-mix(in srgb, #6366f1 10%, transparent);
}

.sa-user-row--clickable:focus-visible {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 2px color-mix(in srgb, #6366f1 25%, transparent);
}

.sa-user-row--active {
  border-color: #6366f1;
  box-shadow: 0 0 0 2px color-mix(in srgb, #6366f1 18%, transparent);
}

.sa-user-row__main {
  display: grid;
  grid-template-columns: minmax(200px, 1.5fr) minmax(160px, 1fr) minmax(168px, auto);
  gap: 10px;
  align-items: center;
  padding: 14px 16px;
}

.sa-user-row__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 0;
}

.sa-user-row__actions-group {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px;
  border-radius: 10px;
  border: 1px solid color-mix(in srgb, var(--border-primary) 80%, transparent);
  background: color-mix(in srgb, var(--bg-secondary) 65%, var(--bg-primary));
  box-shadow: inset 0 1px 0 color-mix(in srgb, #fff 6%, transparent);
}

.sa-user-row__chevron {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  color: var(--text-tertiary, var(--text-secondary));
  background: transparent;
  transition: color 0.15s ease, background 0.15s ease;
}

.sa-user-row--clickable:hover .sa-user-row__chevron {
  color: #6366f1;
  background: color-mix(in srgb, #6366f1 10%, transparent);
}

.sa-user-row__id {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.sa-user-row__avatar {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 800;
  color: #fff;
  letter-spacing: 0.02em;
}

.sa-user-row__text {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.sa-user-row__name-line {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.sa-user-row__name {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--text-primary);
  line-height: 1.3;
}

.sa-user-row__email {
  font-size: 11px;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sa-user-row__flags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 2px;
}

.sa-tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 7px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  line-height: 1.35;
  border: 1px solid transparent;
}

.sa-tag--sm {
  font-size: 9px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
  padding: 1px 6px;
}

.sa-tag--free {
  color: #6b7280;
  background: color-mix(in srgb, #9ca3af 12%, transparent);
  border-color: color-mix(in srgb, #9ca3af 22%, transparent);
}

.sa-tag--start {
  color: #15803d;
  background: color-mix(in srgb, #22c55e 12%, transparent);
  border-color: color-mix(in srgb, #22c55e 26%, transparent);
}

.sa-tag--pro {
  color: #0369a1;
  background: color-mix(in srgb, #38bdf8 12%, transparent);
  border-color: color-mix(in srgb, #38bdf8 26%, transparent);
}

.sa-tag--corp {
  color: #b45309;
  background: color-mix(in srgb, #f59e0b 12%, transparent);
  border-color: color-mix(in srgb, #f59e0b 26%, transparent);
}

.sa-tag--warn {
  color: #b45309;
  background: color-mix(in srgb, #f59e0b 14%, transparent);
  border-color: color-mix(in srgb, #f59e0b 28%, transparent);
}

.sa-tag--stripe {
  color: #4f46e5;
  background: color-mix(in srgb, #6366f1 12%, transparent);
  border-color: color-mix(in srgb, #6366f1 26%, transparent);
}

.sa-tag--due {
  color: #c2410c;
  background: color-mix(in srgb, #fb923c 14%, transparent);
  border-color: color-mix(in srgb, #fb923c 28%, transparent);
}

.sa-tag--valor {
  color: #047857;
  background: color-mix(in srgb, #10b981 14%, transparent);
  border-color: color-mix(in srgb, #10b981 28%, transparent);
}

.sa-billing-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin: 0 0 12px;
  padding: 0 2px;
}

.sa-billing-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.sa-billing-filter {
  padding: 5px 10px;
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  background: var(--bg-secondary);
  color: var(--text-secondary);
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;
}

.sa-billing-filter:hover {
  border-color: color-mix(in srgb, #6366f1 35%, var(--border-primary));
  color: var(--text-primary);
}

.sa-billing-filter--active {
  border-color: color-mix(in srgb, #6366f1 50%, var(--border-primary));
  background: color-mix(in srgb, #6366f1 10%, var(--bg-secondary));
  color: #4f46e5;
}

.sa-billing-sort {
  min-width: 180px;
  padding: 6px 10px;
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 12px;
  font-weight: 600;
}

.sa-billing-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 9px;
  font-weight: 700;
  line-height: 1.35;
  border: 1px solid transparent;
}

.sa-billing-badge svg {
  width: 12px;
  height: 12px;
}

.sa-billing-badge--warn {
  color: #b45309;
  background: color-mix(in srgb, #fbbf24 18%, transparent);
  border-color: color-mix(in srgb, #f59e0b 30%, transparent);
}

.sa-billing-badge--overdue {
  color: #b91c1c;
  background: color-mix(in srgb, #ef4444 14%, transparent);
  border-color: color-mix(in srgb, #ef4444 28%, transparent);
}

.sa-billing-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 8px;
  border: 1px solid transparent;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.sa-billing-btn svg {
  width: 16px;
  height: 16px;
}

.sa-billing-btn:hover,
.sa-billing-btn--active {
  border-color: color-mix(in srgb, #6366f1 28%, transparent);
  color: #4f46e5;
  background: color-mix(in srgb, #6366f1 12%, var(--bg-primary));
  box-shadow: 0 1px 4px color-mix(in srgb, #6366f1 18%, transparent);
}

.sa-user-row__actions-group :deep(.sa-role-picker-wrap) {
  min-width: 102px;
}

.sa-user-row__metrics {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.sa-kpi {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.sa-kpi--ws {
  flex: 1;
  min-width: 72px;
  max-width: 120px;
}

.sa-kpi__label {
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-tertiary, var(--text-secondary));
}

.sa-kpi__val {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
  color: var(--text-primary);
  line-height: 1.3;
}

.sa-kpi__val strong {
  font-weight: 700;
}

.sa-kpi__access {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.sa-kpi__sub {
  font-size: 10px;
  font-weight: 600;
  color: var(--text-tertiary, var(--text-secondary));
  line-height: 1.2;
}

.sa-kpi__sub--stale {
  color: #dc2626;
}

.sa-kpi__val--stale {
  color: #dc2626;
  font-weight: 600;
}

.sa-kpi--stale .sa-kpi__label {
  color: #dc2626;
}

.sa-kpi__warn-icon {
  width: 13px;
  height: 13px;
  flex-shrink: 0;
  color: #dc2626;
}

.sa-kpi__bar {
  display: block;
  height: 3px;
  margin-top: 4px;
  border-radius: 999px;
  background: color-mix(in srgb, var(--border-primary) 75%, transparent);
  position: relative;
  overflow: hidden;
}

.sa-kpi__bar::after {
  content: '';
  position: absolute;
  inset: 0 auto 0 0;
  width: var(--pct, 0%);
  border-radius: inherit;
  background: linear-gradient(90deg, #6366f1, #8b5cf6);
  transition: width 0.3s ease;
}

.sa-kpi__bar--limit::after {
  background: linear-gradient(90deg, #f59e0b, #ef4444);
}

.sa-user-row__tools {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 7px 14px 9px 60px;
  background: color-mix(in srgb, var(--bg-secondary) 45%, transparent);
  border-top: 1px dashed color-mix(in srgb, var(--border-primary) 55%, transparent);
}

.sa-user-row__tools-primary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 10px;
}

.sa-user-row__tools-estrut {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  padding-top: 6px;
  border-top: 1px dashed color-mix(in srgb, var(--border-primary) 40%, transparent);
}

.sa-tool {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.sa-tool--grow {
  flex: 1;
  min-width: min(100%, 280px);
  flex-wrap: wrap;
}

.sa-tool__lbl {
  font-size: 10px;
  font-weight: 600;
  color: var(--text-secondary);
  white-space: nowrap;
}

.sa-tool__sep {
  width: 1px;
  height: 22px;
  background: var(--border-primary);
  flex-shrink: 0;
  margin: 0 2px;
}

.sa-tool--estrut {
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
  width: 100%;
}

.sa-estrut-toggles {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 10px;
}

.sa-access-switch--compact {
  gap: 4px;
}

.sa-access-switch__state--compact {
  font-size: 10px;
  max-width: 5.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sa-tool__input,
.sa-tool__select {
  padding: 5px 8px;
  border-radius: 6px;
  border: 1px solid var(--border-primary);
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 12px;
  min-width: 0;
}

.sa-tool__input {
  width: 56px;
}

.sa-tool__input--day {
  width: 44px;
}

.sa-tool__input--days {
  width: 48px;
}

.sa-tool__select {
  min-width: 100px;
  max-width: 140px;
  flex: 1;
}

.sa-tool__input:focus,
.sa-tool__select:focus {
  outline: none;
  border-color: color-mix(in srgb, #6366f1 45%, var(--border-primary));
}

.sa-tool__btn {
  padding: 5px 10px;
  border-radius: 6px;
  border: none;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  color: #fff;
  background: linear-gradient(135deg, #6366f1, #7c3aed);
  white-space: nowrap;
  transition: filter 0.15s ease;
}

.sa-tool__btn:hover {
  filter: brightness(1.06);
}

.sa-tool__btn--muted {
  color: var(--text-primary);
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
}

.sa-tool__btn--accent {
  background: linear-gradient(135deg, #f59e0b, #d97706);
}

.sa-tool--access {
  min-width: 168px;
}

.sa-access-switch {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  user-select: none;
}

.sa-access-switch__input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.sa-access-switch__track {
  position: relative;
  width: 44px;
  height: 24px;
  border-radius: 999px;
  background: color-mix(in srgb, #22c55e 35%, var(--border-primary));
  border: 1px solid color-mix(in srgb, #22c55e 40%, transparent);
  transition: background 0.2s ease, border-color 0.2s ease;
}

.sa-access-switch__input:not(:checked) + .sa-access-switch__track {
  background: color-mix(in srgb, #ef4444 18%, var(--bg-secondary));
  border-color: color-mix(in srgb, #ef4444 35%, transparent);
}

.sa-access-switch__thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 4px color-mix(in srgb, #000 18%, transparent);
  transition: transform 0.2s ease;
}

.sa-access-switch__input:not(:checked) + .sa-access-switch__track .sa-access-switch__thumb {
  transform: translateX(20px);
}

.sa-access-switch__state {
  font-size: 11px;
  font-weight: 600;
  color: #15803d;
  min-width: 52px;
}

.sa-access-switch__state--off {
  color: #dc2626;
}

.sa-tag--blocked {
  color: #dc2626;
  background: color-mix(in srgb, #ef4444 12%, transparent);
  border-color: color-mix(in srgb, #ef4444 26%, transparent);
  text-transform: none;
}

.sa-add-user-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  padding: 10px 18px;
  border-radius: 10px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  cursor: pointer;
  box-shadow: 0 4px 14px color-mix(in srgb, #6366f1 32%, transparent);
  transition: transform 0.12s ease, box-shadow 0.15s ease;
}

.sa-add-user-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px color-mix(in srgb, #6366f1 40%, transparent);
}

/* Table (workspaces) */
.table-wrap {
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  overflow: hidden;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table thead th {
  background: color-mix(in srgb, var(--bg-primary) 90%, transparent);
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-secondary);
  padding: 12px 14px;
  text-align: left;
  border-bottom: 1px solid var(--border-primary);
}

.data-table tbody td {
  padding: 14px;
  border-bottom: 1px solid var(--border-primary);
  vertical-align: middle;
}

.data-row:last-child td {
  border-bottom: none;
}

.data-row:hover {
  background: color-mix(in srgb, var(--accent-primary) 6%, transparent);
}

.id-badge {
  font-family: ui-monospace, monospace;
  font-size: 12px;
  color: var(--text-secondary);
  background: var(--bg-primary);
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid var(--border-primary);
}

.ws-name {
  font-weight: 600;
  font-size: 14px;
}

.tipo-badge {
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.tipo-badge--crm {
  color: #22c55e;
  background: rgba(34, 197, 94, 0.12);
  border: 1px solid rgba(34, 197, 94, 0.3);
}

.tipo-badge--task {
  color: #38bdf8;
  background: rgba(56, 189, 248, 0.12);
  border: 1px solid rgba(56, 189, 248, 0.3);
}

.tipo-badge--servicos {
  color: #0ea5e9;
  background: rgba(14, 165, 233, 0.12);
  border: 1px solid rgba(14, 165, 233, 0.3);
}

.creator-email {
  font-size: 13px;
  color: var(--text-secondary);
}

.status-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 5px 10px;
  font-size: 11px;
  font-weight: 700;
  border: 1px solid transparent;
}

.status-active {
  color: #22c55e;
  border-color: rgba(34, 197, 94, 0.4);
  background: rgba(34, 197, 94, 0.12);
}

.status-inactive {
  color: #ef4444;
  border-color: rgba(239, 68, 68, 0.4);
  background: rgba(239, 68, 68, 0.12);
}

.empty-state {
  text-align: center !important;
  color: var(--text-secondary);
  padding: 32px 20px !important;
}

.sa-ws-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 12px;
}

.sa-ws-empty {
  grid-column: 1 / -1;
  margin: 0;
  padding: 32px 20px;
  text-align: center;
  color: var(--text-secondary);
  font-size: 14px;
}

.sa-ws-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px;
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  border-left: 3px solid var(--ws-accent, #5865F2);
  background: var(--bg-primary);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.sa-ws-card:hover {
  border-color: color-mix(in srgb, var(--border-primary) 60%, var(--ws-accent, #6366f1));
  border-left-color: var(--ws-accent, #5865F2);
  box-shadow: 0 4px 14px color-mix(in srgb, var(--ws-accent, #6366f1) 12%, transparent);
}

.sa-ws-card--inactive {
  opacity: 0.82;
}

.sa-ws-card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.sa-ws-card__thumb {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid color-mix(in srgb, var(--ws-accent, #5865F2) 28%, var(--border-primary));
  background: color-mix(in srgb, var(--ws-accent, #5865F2) 12%, var(--bg-primary));
}

.sa-ws-card__photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.sa-ws-card__initial {
  font-size: 15px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.02em;
}

.sa-ws-card__badges {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
}

.sa-ws-card__body {
  flex: 1;
  min-width: 0;
}

.sa-ws-card__name {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.35;
  color: var(--text-primary);
  word-break: break-word;
}

.sa-ws-card__owner {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
  min-width: 0;
}

.sa-ws-card__owner-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
}

.sa-ws-card__owner-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.sa-ws-card__owner-text {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.sa-ws-card__owner-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sa-ws-card__creator {
  margin: 0;
  font-size: 12px;
  color: var(--text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sa-ws-card__members {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid color-mix(in srgb, var(--border-primary) 70%, transparent);
}

.sa-ws-card__member-stack {
  display: flex;
  align-items: center;
}

.sa-ws-card__member-avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 2px solid var(--bg-primary);
  background: var(--bg-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  font-size: 10px;
  font-weight: 700;
  color: var(--text-secondary);
}

.sa-ws-card__member-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.sa-ws-card__member-avatar--more {
  background: color-mix(in srgb, var(--ws-accent, #6366f1) 18%, var(--bg-secondary));
  color: var(--text-primary);
  font-size: 9px;
}

.sa-ws-card__member-count {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: var(--text-secondary);
  white-space: nowrap;
}

.sa-ws-card__foot {
  padding-top: 4px;
}

.sa-ws-card__open {
  width: 100%;
  border: 1px solid color-mix(in srgb, #6366f1 35%, var(--border-primary));
  border-radius: 8px;
  background: color-mix(in srgb, #6366f1 10%, var(--bg-primary));
  color: #6366f1;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.sa-ws-card__open:hover:not(:disabled) {
  background: color-mix(in srgb, #6366f1 18%, var(--bg-primary));
  border-color: #6366f1;
}

.sa-ws-card__open:disabled {
  opacity: 0.65;
  cursor: wait;
}

.pagination {
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid var(--border-primary);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.pagination-info {
  font-size: 13px;
  color: var(--text-secondary);
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-page {
  border: 1px solid var(--border-primary);
  border-radius: 4px;
  background: var(--bg-primary);
  color: var(--text-primary);
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.btn-page:hover:not(:disabled) {
  border-color: color-mix(in srgb, var(--accent-primary) 40%, var(--border-primary));
  background: var(--bg-secondary);
}

.btn-page:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.page-indicator {
  font-size: 13px;
  color: var(--text-secondary);
  padding: 0 6px;
}

@media (max-width: 1100px) {
  .kpi-grid {
    grid-template-columns: 1fr;
  }
  .sa-billing-totals {
    grid-template-columns: 1fr;
  }
  .sa-users-list__head {
    display: none;
  }
  .sa-user-row__main {
    grid-template-columns: 1fr auto;
    grid-template-rows: auto auto;
  }
  .sa-user-row__id {
    grid-column: 1 / -1;
  }
  .sa-user-row__metrics {
    grid-column: 1;
  }
  .sa-user-row__actions {
    grid-column: 2;
    grid-row: 2;
    align-self: start;
  }
}

@media (max-width: 768px) {
  .main-title {
    font-size: 1.5rem;
  }
  .title-section {
    flex-direction: column;
    align-items: flex-start;
  }
  .count-pill {
    margin-left: 0;
  }
  .sa-content {
    padding: 16px;
  }
  .header-container {
    padding: 0 16px;
  }
  .pagination {
    flex-direction: column;
    align-items: flex-start;
  }
  .sa-user-row__main {
    grid-template-columns: 1fr;
  }
  .sa-user-row__metrics {
    flex-direction: row;
    flex-wrap: wrap;
  }
  .sa-user-row__actions {
    justify-content: flex-start;
  }
  .sa-tool--grow {
    width: 100%;
  }
  .sa-tool__sep {
    display: none;
  }
  .sa-add-user-btn {
    width: 100%;
    justify-content: center;
    margin-left: 0;
  }
}
</style>

<style>
body.tema_escura .super-admin-page .sa-tool__select {
  color-scheme: dark;
}
body.tema_clara .super-admin-page .sa-tool__select {
  color-scheme: light;
}
</style>
